// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__wVu50","obliqueLineWrap":"membershipbadge_obliqueLineWrap__9_v-H","obliqueLine":"membershipbadge_obliqueLine__oMmuT"};